import React, { useState, useCallback, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const ListCard = (item) => {
    return (
        <div className="admin-content-list-inner">
            <div className="icon fa fa-grip-vertical margin-right-1" />
            <h6>{item.title || item.name || item.id}</h6>
            {/* <i className='margin-left-1 far fa-pencil admin-content-list-edit' onClick={(e) => {
                e.stopPropagation();
                openList(item);
            }}></i> */}
        </div>
    );
}

const ContentList = ({playlistStore, clickHandler, onOrderChange}) => {
    
    const [loading, setLoading] = useState(true);
    const [playlistItems, setPlaylistItems] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            await playlistStore.fetchItems();
            const sortedItems = [...playlistStore.items].sort((a, b) => a.position - b.position);
            setPlaylistItems(sortedItems);
            setLoading(false);
        };

        fetchData();
    }, [playlistStore, loading]);

    const updatePositions = (items) => {
        return items.map((item, index) => ({
            ...item,
            position: index + 1
        }));
    };

    const onDragEnd = useCallback((result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const reorderedItems = reorder(
            playlistItems,
            result.source.index,
            result.destination.index
        );

        const updatedItems = updatePositions(reorderedItems);
        setPlaylistItems(updatedItems);
        if (typeof onOrderChange === 'function') {
            onOrderChange(updatedItems);
        }
    }, [playlistItems, onOrderChange]);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (!playlistItems.length) {
        return (
            <h6>No lists have been created.</h6>
        );
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {playlistItems.map((item, index) => {
                            const draggableId = `${item._id || item.id}`;

                            return (
                                <Draggable
                                    key={draggableId}
                                    draggableId={draggableId}
                                    index={index}
                                >
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className="admin-content-listitem"
                                        style={provided.draggableProps.style}
                                        onClick={() => clickHandler(item)}
                                    >
                                        <ListCard { ...item } />
                                        <div className="list-type-badge">
                                            {item.listType}
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        );})}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}

export default ContentList;